<!--
 * @Descripttion: 
 * @FilePath: /mall-wap-vue/src/App.vue
 * @Author: 张兴业
 * @Date: 2020-09-24 10:19:31
 * @LastEditors: hl
 * @LastEditTime: 2026-06-17 16:31:20
-->
<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
import { changeFavicon, configTitle } from "@/global";
import { getToken, getCurrentRole } from "@/utils/authority";

export default {
  created() {
    const token = getToken();
    const role = getCurrentRole();
    if (!token || role === "Guest") {
      // 未登录或为游客状态：获取游客 token -> 初始化用户信息、角色与地址数据
      this.$store
        .dispatch("login/getGuestToken")
        .then(() => {
          return this.initUserData();
        })
        .catch(err => {
          console.error("初始化游客身份或获取数据失败:", err);
        });
    } else {
      // 已登录且不是游客身份：初始化用户信息、角色与地址数据
      this.initUserData().catch(err => {
        console.error("更新登录用户角色或获取地址失败:", err);
        // 故障兜底，直接拉取地址数据以防网络抖动导致交互失败
        this.$store.dispatch("mine/getAllAddress").catch(() => {});
      });
    }
  },
  mounted() {
    changeFavicon();
    configTitle();
  },
  methods: {
    /**
     * 初始化用户信息、更新本地角色状态并拉取地址数据
     * @returns {Promise}
     */
    initUserData() {
      return this.$store.dispatch("mine/getUserInfo").then(() => {
        return this.$store.dispatch("mine/getAllAddress");
      });
    }
  }
};
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #f6f7f8;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
